import React from "react";
const dropShipping_orders = ({
  isSelectedFather,
  isSingle = false,
  isHeader = false
}: {
  isSelectedFather?: Boolean;
  isSingle?: Boolean;
  isHeader?: Boolean;
}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={isHeader ? "#6266FF" : isSelectedFather ? isSingle ? "rgb(255,255,255)" : "url(#Gradient2)" : "rgb(12,23,42,0.8)"} width="16px" height="16px" data-sentry-element="svg" data-sentry-component="dropShipping_orders" data-sentry-source-file="dropshipping_orders.tsx">
      <path d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z" data-sentry-element="path" data-sentry-source-file="dropshipping_orders.tsx" />
      <path d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z" data-sentry-element="path" data-sentry-source-file="dropshipping_orders.tsx" />
      <path d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z" data-sentry-element="path" data-sentry-source-file="dropshipping_orders.tsx" />
    </svg>;
};
export default dropShipping_orders;